<script setup>
import { computed, inject } from 'vue';
import { flowThreadContextKey } from './flowThreadContext';
import NodeTextareaField from '../ui/NodeTextareaField.vue';

const props = defineProps({
  node: {
    type: Object,
    required: true,
  },
  isSelected: {
    type: Boolean,
    default: false,
  },
});

const context = inject(flowThreadContextKey);
const hasBodyValue = computed(() => Boolean(props.node.config?.body?.trim?.()));
const messageBody = computed(() => props.node.config?.body || '');
const messageMetaClass = computed(() =>
  props.isSelected ? 'text-[#0f6b5a]/80' : 'text-n-slate-10'
);
</script>

<template>
  <div class="bg-[#dcf8c6] px-3 py-2.5">
    <NodeTextareaField
      v-if="isSelected"
      :model-value="node.config?.body || ''"
      min-height="3.25rem"
      max-height="6rem"
      :placeholder="context.uiCopy.inlineTextPlaceholder"
      @update:model-value="context.updateNode({ body: $event })"
    />
    <p
      v-else
      class="whitespace-pre-wrap text-[12px] leading-5"
      :class="hasBodyValue ? 'text-n-slate-12' : 'text-n-slate-9'"
    >
      {{ messageBody || context.uiCopy.inlineTextPlaceholder }}
    </p>

    <div class="mt-1.5 flex items-center justify-end gap-1 text-[10px]">
      <span :class="messageMetaClass">{{ context.uiCopy.timestamp }}</span>
      <i class="i-lucide-check-check text-[11px] text-[#53bdeb]" />
    </div>
  </div>
</template>
